import { useFormik } from 'formik';
import React from 'react'
import * as Yup from 'yup';
import { MissionDocuments as documents } from './documents';
import CustomTextarea from '../../../Components/textareaComp/CustomTextarea';
import ButtonComp from '../../../Components/ButtonComp/ButtonComp';
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useQuery } from '@tanstack/react-query';
import { MissionGet } from '../../../Store/auth/register';

const Mission = ({setSubTabs}) => {
    const application_no = localStorage.getItem('RegKey')
    const getGsnNo = localStorage.getItem('gsn_no')
    const { isLoading: fieldLoading, data: questions } = useQuery({
        queryKey: 'mission',
        queryFn: () => MissionGet(getGsnNo ? getGsnNo :''),
    });

    
    const mission_description = questions?.data?.mission_description
    

    const modelSchema = Yup.object().shape({
        ...questions?.documents?.reduce((schema, fields) => {
            if (fields.type.toLowerCase() !== 'section') {
                // Define validation rules
                let fieldValidation = Yup.string();
                if (fields?.depend_question && (fields.type.toLowerCase() === 'password' || fields.validation.toLowerCase() === 'email')) {
                    fieldValidation = fieldValidation.test(
                        'match-dependent',
                        `${fields.question} must match the related field`,
                        function (value) {
                            const { parent } = this;
                            const dependentValue = parent[fields.depend_question];

                            if (fields.type.toLowerCase() === 'password') {
                                return value === dependentValue;
                            } else if (fields.validation.toLowerCase() === 'email') {
                                return value === dependentValue;
                            }

                            return true;
                        }
                    );
                }
                // Apply different validation rules based on the field's validation type
                if (fields.validation.toLowerCase() === 'email' && !fields?.depend_question) {
                    fieldValidation = fieldValidation.matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Invalid email address'
    );
                } else if (fields.validation.toLowerCase() === 'pan') {
                    fieldValidation = fieldValidation.matches(
                        /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        'Invalid PAN Number. It should be in the format: ABCDE1234F.'
                    );
                } else if (fields.validation.toLowerCase() === 'pincode') {
                    fieldValidation = Yup.string().matches(
                        /^\d{4}$|^\d{6}$/,
                        'PIN code must be exactly 6 digits'
                    );
                } else if (fields.validation.toLowerCase() === 'areacode') {
                    fieldValidation = fieldValidation.matches(
                        /^(123|456|789)$/,
                        'Incorrect area code'
                    );
                } else if (fields.type.toLowerCase() === 'multiselect dropdown') {
                    fieldValidation = Yup.array();
                } else if (fields.validation.toLowerCase() === 'website') {
                    fieldValidation = fieldValidation.url('Please enter a valid URL');
                } else if (fields.validation.toLowerCase() === 'mobile') {
                    fieldValidation = fieldValidation.matches(
                        /^(?:[0-9]{10}|[0-9]{7})$/,
                        'Invalid contact number'
                    );
                } else if (fields.type.toLowerCase() === 'attach') {
                    fieldValidation = Yup.object();
                } else if (fields.validation.toLowerCase() === 'darpan') {
                    fieldValidation = fieldValidation.test(
                        'is-valid-darpan',
                        'Invalid PAN Darpan Id. It should be in the format: XX/1234/1234567.',
                        (value) => {
                            if (value?.toUpperCase() === 'NA') {
                                return true;
                            }
                            return /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value);
                        }
                    );
                } else if (fields.validation.toLowerCase() === 'password' && !fields?.depend_question) {
                    fieldValidation = fieldValidation.min(8, 'Password must be at least 8 characters long');
                }

                // Apply required validation if the field is mandatory
                if (fields.mandatory === 1) {
                    fieldValidation = fieldValidation.required(`${fields.question} is required`);
                }

                // Assign the validation rule to the field in the schema
                schema[fields?.question_no] = fieldValidation;
            }

            return schema;
        }, {}),
    });
    const createInitialValues = () => {
        if (questions?.docs_answers?.length > 0) {
            return questions.docs_answers.reduce((values, field) => {
                if (field.type.toLowerCase() === 'section') {
                    // Initialize section with template name as an array of objects
                    if (field?.answer?.length > 0) {
                        const tempData = [];
                        field.answer.forEach((Row, index) => {
                            Row.forEach(Field => {
                                if (!tempData[index]) tempData[index] = {}; // Ensure initialization

                                if (Field.type.toLowerCase() === 'multiselect dropdown') {
                                    tempData[index][Field?.question_no] = Field?.answer?.split(',') || [];
                                }
                                else if (Field?.type.toLowerCase() === "attach") {
                                    tempData[index][Field?.question_no] = { file_name: Field?.upload_document }
                                }
                                else {
                                    tempData[index][Field?.question_no] = Field?.answer || ''; // Ensure default empty value
                                }
                            });
                        });
                        values[field.template] = values[field.template] || tempData; // Ensure array initialization
                    } else {
                        values[field.template] = values[field.template] || [{}]; // Ensure array initialization
                        values[field.template].forEach(row => {
                            field?.sub_questions?.forEach(subField => {
                                row[subField?.question_no] = subField?.question === 'Country Code' ? '+91 - India' : '';
                            });
                        });
                    }
                } else {
                    // Normal fields, assign to `normalFields`
                    values.normalFields = values.normalFields || {};
                    if (field?.question_no) {
                        if (field.type.toLowerCase() === 'multiselect dropdown') {
                            values.normalFields[field.question_no] = field?.answer?.split(',') || [];
                        } else if (field?.type.toLowerCase() === "attach") {
                            values.normalFields[field.question_no] = { file_name: field?.upload_document }
                        }
                        else {
                            values.normalFields[field.question_no] = field?.answer || ''; // Ensure default empty value
                        }
                    }
                }
                return values;
            }, {});
        } else {
            return questions?.documents?.reduce((values, field) => {
                values.normalFields = values.normalFields || {};
                values.normalFields[field?.question_no] = '';

                if (field.type.toLowerCase() === 'section') {
                    if (field?.answer?.length > 0) {
                        const tempData = [];
                        field.answer.forEach((Row, index) => {
                            Row.forEach(Field => {
                                if (!tempData[index]) tempData[index] = {}; // Ensure initialization

                                tempData[index][Field?.question_no] = Field?.answer || ''; // Ensure default empty value
                            });
                        });
                        values[field.template] = values[field.template] || tempData; // Ensure array initialization
                    } else {
                        values[field.template] = values[field.template] || [{}]; // Ensure array initialization
                        values[field.template].forEach(row => {
                            field?.sub_questions?.forEach(subField => {
                                row[subField?.question_no] = subField?.question === 'Country Code' ? '+91 - India' : '';
                            });
                        });
                    }
                }
                return values;
            }, {});
        }
    };
    

    const formik = useFormik({
        initialValues: documents?.reduce((values, fields,) => {
            values[fields?.question_no] = '';  // Initializing values for each field dynamically
            return values;
        }, {}),
        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const tempData = questions?.documents?.map(fields => {
                    if (fields?.type.toLowerCase() === 'attach' && values?.[fields.question_no]) {
                        return {
                            question_no: fields?.question_no,
                            attach_file: values?.[fields?.question_no]?.file64,
                            file_name: values?.[fields?.question_no]?.fileName
                        };
                    }
                    
                    else {
                        return {
                            question_no: fields?.question_no,
                            answer: values[fields?.question_no]
                        };
                    }
                });


                const structuredData = {
                    args: {
                        name: '',
                        initial_registration_answers: tempData
                    }
                };
                
                // await submitData(structuredData);
                setSubTabs({ "Strategy & Goals": true })
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    const SeeWhatWeDo = () => {
        setTimeout(() => {
            setSubTabs({ "What We Do": true })
        }, 1000);
        
    };
  return (
    <>
        <form className='flex flex-col gap-[10px]  min-h-[90vh] justify-between'  action="" onSubmit={formik.handleSubmit}>
            <div className='flex flex-col gap-[30px] justify-between w-[100%]'>
                <div className=''>
                    <ParagraphComp className='font-bold text-lg' text='Mission Statement' />
                </div>
                <div className='flex flex-wrap justify-between w-[100%]'>
                        {documents.slice(0 , 1).map(Fields =>
                        <>
                        { Fields.type.toLowerCase() === 'text'?
                            <div className='w-[100%]'>
                                <CustomTextarea 
                                    required
                                    {...formik.getFieldProps(Fields.question_no)}
                                    value={mission_description}
                                    name={Fields.question_no} label={Fields.question}
                                    onBlur={formik.handleBlur}  
                                />
                                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                            </div>
                                :''
                            }
                        </>
                        )}
                </div>
                <div className='flex justify-center gap-[20px] mt-8'>
                    <ButtonComp onClick={SeeWhatWeDo} text={<><ArrowForwardIcon/> to make changes to this statement click here</>} className='px-[20px] rounded-full bg-[#004878] text-[white] py-[10px]' />
                </div>
            </div>

            <div className='flex justify-end'>
                <div className='flex gap-[20px]'>
                    {/* <ButtonComp text={'Save'} className='px-[20px] rounded-full border-1 border-[#004878] text-[#004878] py-[10px]' /> */}
                    {/* <ButtonComp text={'Save & Next'} className='px-[20px] rounded-full bg-[#004878] text-[white] py-[10px]' /> */}
                </div>
            </div>
            
        </form>
    </>
  )
}

export default Mission